module.exports = __webpack_public_path__ + "img/2.cb9461e9.jpg";